import React from 'react';
import {useTable} from 'react-table';
import {FormattedMessage} from 'react-intl';
import {CommonTable} from '../../_common/components/CommonTable/CommonTable';
import {useTransfersByAgentContext} from '../contexts/TransfersByAgentContext';
import styles from './styles.module.scss';

export function TableUnpaidLines() {
  const {columns, dataUnpaidReceiptLines} = useTransfersByAgentContext();

  return (
    <div>
      <h3>
        <FormattedMessage
          id="transfersByAgent-unpaid-to-agent"
          defaultMessage={`Yet to be paid to agent (${dataUnpaidReceiptLines.length})`}
          values={{count: dataUnpaidReceiptLines.length}}
        />
      </h3>
      <CommonTable
        tableProps={useTable({columns, data: dataUnpaidReceiptLines})}
        customContainerStyles={'w-100'}
        customHeaderStyles={styles.tableHeader}
        customContainerID={'bulkActionsTableContainer'}
        customTableStyles={'transfers-unpaid-lines'}
        customTableHeadColor={'transfers-tableHead'}
      />
    </div>
  )
}

export default TableUnpaidLines;
